import { api } from '@/utils/api'
import { ApiResponseHandler, Postable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaCt130V2 {
  export namespace Post {
    export interface Request {
      body: {
        answerId: string
        imageData: string[]
      }
    }
    export interface Response {
      // none response parameter.
    }
  }

  const path: string = '/v2/ta/sheetAnswers'

  export class Api extends ApiBase implements Postable<Post.Request, Post.Response, ResponseError> {
    public post<R>(
      params: Post.Request,
      successHandler: ApiResponseHandler<Post.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      const validationSample: Post.Response = {
        // none response parameter.
      }
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }
      return this.callbackWrapper<Post.Response, ResponseError, R>(
        api.post<Post.Response>(path, params.body),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
